module.exports = __webpack_public_path__ + "img/6-ashauger.9f67b14a.png";